import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=c4df7876&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=ts"
export * from "./Bar.vue?vue&type=script&lang=ts"
import style0 from "./Bar.vue?vue&type=style&index=0&id=c4df7876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4df7876",
  null
  
)

export default component.exports